import type {AssigneePickerBaseAssignee} from '@github-ui/item-picker-assignee'
import type {RecordSourceSelectorProxy} from 'relay-runtime'

// Adds the given assignee to the issue's assignedActors in the Relay store
// Does nothing if the assignee is already assigned
// Performs a local update only; does not call any mutations
// No limits on the number of assignees are enforced here
export const addAssigneeToIssueLocally = (
  store: RecordSourceSelectorProxy<object>,
  issueId: string,
  assignee: AssigneePickerBaseAssignee,
) => {
  const issueRecord = store.get(issueId)
  if (issueRecord) {
    const assignedActors = issueRecord.getLinkedRecord('assignedActors(first:20)')
    if (assignedActors) {
      const nodes = assignedActors.getLinkedRecords('nodes') || []

      const assigneeAlreadyAssigned = nodes.some(node => node && node.getValue('id') === assignee.id)
      if (!assigneeAlreadyAssigned) {
        let assigneeRecord = store.get(assignee.id)
        if (!assigneeRecord) {
          assigneeRecord = createAssigneeRecord(store, assignee)
        }

        const updatedNodes = [...nodes, assigneeRecord].sort((a, b) => {
          const loginA = (a?.getValue('login') as string) || ''
          const loginB = (b?.getValue('login') as string) || ''
          return loginA.toLowerCase().localeCompare(loginB.toLowerCase())
        })
        assignedActors.setLinkedRecords(updatedNodes, 'nodes')
      }
    }
  }
}

const createAssigneeRecord = (store: RecordSourceSelectorProxy<object>, assignee: AssigneePickerBaseAssignee) => {
  const assigneeRecord = store.create(assignee.id, assignee.__typename)

  const propertiesToSet: AssigneePickerBaseAssignee = {
    id: assignee.id,
    login: assignee.login,
    name: assignee.name,
    avatarUrl: assignee.avatarUrl,
    isCopilot: assignee.isCopilot,
    profileResourcePath: assignee.profileResourcePath,
    __typename: assignee.__typename,
  }
  for (const [key, value] of Object.entries(propertiesToSet)) {
    assigneeRecord.setValue(value, key)
  }
  return assigneeRecord
}
